import { intersect } from './intersect';
import { isMobile } from '@sky-it-livedata/common-web-app-utils';

const hero = document.querySelector<HTMLElement>('.ftbl__lgp-hero-container[data-hero-slim= sticky]');
const heroSlim = document.querySelector<HTMLElement>('.ftbl__lgp-hero-sticky-container[data-hero-slim= sticky]');


const toIntersect = (item: HTMLElement) => {
  if (item.parentNode) {
    Array.prototype.filter.call(item.parentNode.children, (i: HTMLElement) => {
      if (i.dataset.heroSlim === 'sticky') {
        i.dataset.state = 'isHidden';
      }
    });

    item.dataset.state = 'isVisible';
  }
};

export const heroSlimSticky = () => {
  const localNavElement = document.querySelector<HTMLElement>('.j-local-nav');
  const sectionNavElement = document.querySelector<HTMLElement>('.j-section-nav');
  const tabsMenuElement = document.querySelector<HTMLElement>('.j-tabs-menu');

  if (!hero || !heroSlim || !localNavElement || !sectionNavElement) {
    // eslint-disable-next-line no-console
    console.info('🚫 HERO SLIM STICKY disabled');
    return;
  }

  // eslint-disable-next-line no-console
  console.info('🚫🚫🚫🚫🚫🚫🚫');

  const heroSlimElementHeightDefaults: number = isMobile() ? 63 : 66;
  const heroElementHeight = hero.getBoundingClientRect().height;
  const heroSlimElementHeight =
    heroSlim.getBoundingClientRect().height || heroSlimElementHeightDefaults;
  const localNavElementHeight = localNavElement.getBoundingClientRect().height;
  const sectionNavElementHeight = sectionNavElement.getBoundingClientRect().height;

  let sumStickyElements: number = isMobile()
    ? localNavElementHeight + heroSlimElementHeight // use the local nav because in mobile the section nav is in display none
    : localNavElementHeight + sectionNavElementHeight + heroSlimElementHeight;

  const threshold = ((100 / heroElementHeight) * sumStickyElements) / 100;

  heroSlim.style.top = isMobile()
    ? `${localNavElementHeight}px` // use the local nav because in mobile the section nav is in display none
    : `${localNavElementHeight + sectionNavElementHeight}px`;
  heroSlim.style.marginTop = `-${heroSlimElementHeight}px`;

  if (tabsMenuElement) {
    sumStickyElements = sumStickyElements > 196 ? 130 : sumStickyElements;
    tabsMenuElement.style.top = `${sumStickyElements - 1}px`;
  }

  const intersector = intersect('[data-hero-slim= sticky]', threshold);
  intersector(toIntersect);
};
